import Fuse, { IFuseOptions } from "fuse.js";
import { Suggestion } from "../@types/SearchAutosuggest";

export function getLastQueryToken(query: string) {
  let value = query;
  const colonIndex = query.indexOf(":");
  const openBracketIndex = query.lastIndexOf("[");
  const lastBracketIndex = query.lastIndexOf("]");
  const lastCommaIndex = query.lastIndexOf(",");
  if (colonIndex > -1) {
    value = query.substring(colonIndex + 1, query.length);
  }

  if (openBracketIndex > -1) {
    value = query.substring(
      openBracketIndex + 1,
      lastBracketIndex < openBracketIndex ? query.length : lastBracketIndex
    );

    if (lastCommaIndex > -1) {
      value = query.substring(
        lastCommaIndex + 1,
        lastBracketIndex < openBracketIndex ? query.length : lastBracketIndex
      );
    }
  }

  value = value.trim().replaceAll('"', "");

  return value;
}

export function getFuzzySuggestions(query: string, suggestions: Suggestion[]) {
  const value = getLastQueryToken(query);
  if (value === "") {
    return suggestions;
  }

  const fuseOptions: IFuseOptions<Suggestion> = {
    threshold: 0.2,
    keys: ["values", "name", "value"],
    ignoreLocation: true
  };
  const fuse = new Fuse(suggestions, fuseOptions);

  return fuse.search(value).map(suggestion => suggestion.item);
}
